import { render, staticRenderFns } from "./DataTableRow.vue?vue&type=template&id=d2535882&scoped=true"
import script from "./DataTableRow.vue?vue&type=script&lang=js"
export * from "./DataTableRow.vue?vue&type=script&lang=js"
import style0 from "./DataTableRow.vue?vue&type=style&index=0&id=d2535882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2535882",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
